import * as React from "react";
import SvgAdd from "./SvgAdd";
import SvgCloudy from "./SvgCloudy";
import SvgDelete from "./SvgDelete";
import SvgLiveStreaming from "./SvgOscilloscope";
import SvgOscilloscope from "./SvgLiveStreaming";
import SvgOverview from "./SvgOverview";
import SvgReport from "./SvgReport";
import SvgSine from "./SvgSine";
import SvgSpectrum from "./SvgSpectrum";
import SvgTelescope from "./SvgTelescope";
import SvgWaveSound from "./SvgWaveSound";
import SvgEdit from "./SvgEdit";
import SvgLogout from "./SvgLogout";
import SvgAvatar from "./SvgAvatart";
import SvgUsersManagement from "./SvgUserManagement";
import SvgGrafana from "./SvgGrafana";
import SvgLocationPin from "./SvgLocationPin";
import SvgPerformanceStation from "./SvgPerformanceStation";
import SvgLocalizationStation from "./SvgLocalizationStation";
import SvgPerformanceLocalizationStation from "./SvgPerformanceLocalizationStation";
import SvgNetwork from "./SvgNetwork";
import SvgInterference from "./SvgInterference";

const Icons = ({ name, ...props }) => {
  switch (name) {
    case "add-icon":
      return <SvgAdd {...props} />;
    case "cloudy-icon":
      return <SvgCloudy {...props} />;
    case "delete-icon":
      return <SvgDelete {...props} />;
    case "live-streaming-icon":
      return <SvgLiveStreaming {...props} />;
    case "oscilloscope-icon":
      return <SvgOscilloscope {...props} />;
    case "overview-icon":
      return <SvgOverview {...props} />;
    case "report-icon":
      return <SvgReport {...props} />;
    case "sine-icon":
      return <SvgSine {...props} />;
    case "interference-icon":
      return <SvgInterference {...props} />
    case "spectrum-icon":
      return <SvgSpectrum {...props} />;
    case "telescope-icon":
      return <SvgTelescope {...props} />;
    case "wave-sound-icon":
      return <SvgWaveSound {...props} />;
    case "edit-icon":
      return <SvgEdit {...props} />;
    case "logout-icon":
      return <SvgLogout {...props} />;
    case "avatar-icon":
      return <SvgAvatar {...props} />;
    case "users-management-icon":
      return <SvgUsersManagement {...props} />;
    case "network-icon":
      return <SvgNetwork {...props} />;
    case "grafana-icon":
      return <SvgGrafana {...props} />;
    case "location-pin-icon":
      return <SvgLocationPin {...props} />;
    case "performance-station-icon":
      return <SvgPerformanceStation {...props} />;
    case "localization-station-icon":
      return <SvgLocalizationStation {...props} />;
      case "performance-localization-station-icon":
      return <SvgPerformanceLocalizationStation {...props} />;
  }
};

export default Icons;
